import { FC } from "react";
import { useSelector } from "react-redux";
import { getDesiredDate, getWeekDays } from "../../../../utils/DateUtils";

interface VerticalLinesProps {
  clickOnDay: ({ date, startTime }: { date: Date; startTime: string }) => void;
}

const VerticalLines: FC<VerticalLinesProps> = ({ clickOnDay }) => {
  const { date } = useSelector(
    (state: { calendar: { date: Date } }) => state.calendar
  );

  const handleSelectDay = (
    e: React.MouseEvent<HTMLDivElement>,
    index: number
  ) => {
    const currentTarget = e.currentTarget as HTMLDivElement;
    const rect = currentTarget.getBoundingClientRect();

    const offsetY = e.clientY - rect.top;
    const divideHeight = Math.floor((offsetY / rect.height) * 24);
    const hour = divideHeight < 17 ? divideHeight + 7 : divideHeight + 7 - 24;
    const startTime = hour >= 10 ? `${hour}:00` : `0${hour}:00`;

    const day = getWeekDays(date)[index];

    clickOnDay({
      date: new Date(day.dayDate),
      startTime,
    });
  };
  return (
    <div className="col-start-1 col-end-2 row-start-1 hidden grid-cols-7 grid-rows-1  sm:grid sm:grid-cols-7  ">
      {[0, 1, 2, 3, 4, 5, 6].map((day) => (
        <div
          className={`col-start-${
            day + 1
          } row-span-full  border-x border-solid border-gray-300  cursor-pointer z-10  `}
          onClick={(e) => handleSelectDay(e, day)}
        />
      ))}
    </div>
  );
};

export default VerticalLines;
